import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { connect, storeKey } from '../store';
import pageReducer from './reducers';
import reducerStore from '../reducer-store';
import { withRouter } from 'react-router-dom';
import {
    loadPageProps,
    setPageProps,
    setLoading
} from './actions';

let _defaultProps = {
    code: '',
    title: '',
    keywords: '',
    description: '',
};
let _defaultPropsMap = {
    code: '页面编码',
    title: '标题',
    keywords: '关键字',
    description: '描述',
};

/**
 * 组件目标：
 * 1、初始化组件模型
 * 2、接管组件属性渲染，服务器端可以传入props，前端异步加载props
 * @param {*} options 
 */
function pageModel(Ele) {

    let defaultProps = Object.assign({}, _defaultProps, Ele.defaultProps || {});
    let propsMap = Object.assign({}, _defaultPropsMap, Ele.propsMap || {});
    class PageWarpper extends Component {
        constructor(props, context) {
            super(props, context);
            this.registerReducer();
        }
        static contextTypes = {
            [storeKey]: PropTypes.object
        }
        registerReducer() {
            let me = this;
            me.store = me.context[storeKey];
            me.store.replaceReducer(reducerStore.add('page', pageReducer));
        }
        postMessage(info = {}) {
            console.log(`post message :${JSON.stringify(info)}`);
            window.top.postMessage(info, '*');
        }
        async  componentDidMount() {
            let me = this;
            let {
                match: {
                    params
                },

                setLoading,
                loadPageProps,
                setPageProps
            } = me.props;
            if (process.env.NODE_ENV == 'development') {
                setLoading(true);
                setPageProps(defaultProps.code, defaultProps);
                setLoading(false);
            } else {
                await loadPageProps(params.domain, defaultProps.code);
            }

            if (window.top !== window) {
                window.addEventListener('message', (e) => {
                    console.log(`rev message: ${JSON.stringify(e.data)}`);
                    let data = e.data;
                    if (data.type == 'set-props') {
                        setPageProps(defaultProps.code, data.props);
                    } else if (data.type == 'reload') {
                        window.location.reload(true);
                    }
                });
                me.postMessage({
                    type: 'init-props',
                    props: Object.assign({}, defaultProps, me.props.pageProps),
                    propsMap: propsMap
                });
                me.postMessage({
                    type: 'page-url',
                    url: window.location.href
                }, '*');
            }
        }
        render() {
            let me = this;

            let {
                isLoading = true,
                pageProps = {}
            } = me.props;

            if (isLoading) {
                return null;
            }

            // console.log(pageProps);
            return <Ele {...me.props} {...pageProps} />;
        }
    }

    let ReduxWarpper = connect((state, props) => {
        if (!state.page) {
            return { isLoading: true };
        }
        let page = state.page;
        let isLoading = page.isLoading;
        let pageProps = page[defaultProps.code];
        return {
            isLoading,
            pageProps
        };
    }, (dispatch) => {
        return bindActionCreators({
            setLoading,
            setPageProps,
            loadPageProps
        }, dispatch);
    })(withRouter(PageWarpper));

    ReduxWarpper.services = [{
        reducer: {
            'page': pageReducer
        }
    }];

    ReduxWarpper.need = [
        function (match) {
            let {
                params
            } = match;
            return loadPageProps(params.domain, defaultProps.code);
        }
    ];
    //model属性后期
    // ReduxWarpper.defaultProps = defaultProps;

    //复制原有组件的静态属性
    // for (const key in Ele) {
    //     ReduxWarpper[key] = Ele[key];
    // }

    ReduxWarpper.defaultProps = defaultProps;
    ReduxWarpper.propsMap = propsMap;
    ReduxWarpper.WrappedComponent = Ele;
    return ReduxWarpper;
}

export default pageModel;


function routeComponent(path, page) {
    let code = path.replace(/\/pages\/:domain\/|\/$/g, '').replace(/[^a-zA-Z0-9]+/g, '_') || 'home';
    if (!page.defaultProps) {
        page.defaultProps = {
            code
        };
    } else if (!page.defaultProps.code) {
        page.defaultProps.code = code;
    }
    return pageModel(page);
}

/**
 * 针对路由加包裹，就需要针对每个页面加了
 * @param {Array} routes 路由数组
 */
export function routeWarpper(routes = []) {
    return routes.map((route) => {
        return {
            path: route.path,
            component: routeComponent(route.path, route.component)
        };
    });
}

/**
 * 设置class的默认属性
 */
export function setEditProps(defaultProps = {}, propsMap = {}) {

    return function (target) {

        target.defaultProps = defaultProps;
        target.propsMap = propsMap;
        return target;
    };
}


// WEBPACK FOOTER //
// ./_source/cqsx/services/page-model/index.js